<template>
    <div class="container">
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="0"></breadcrumb-top>
        <div class="content c-top">
            <div class="info1">{{ title }}</div>
            <div class="content-content">
                <div style="display: flex;margin-top: 24px;" v-if="queryData.type == 'add'">

                    <div class="fLabel"><span style="color: red;">*</span>选择商品</div>
                    <div> <el-input size="small" v-model="goodsName" @focus="selectGoods"
                            style="width: 442px;margin-left: 8px;" placeholder="请选择" clearable></el-input></div>
                </div>
                <div style="display: flex;margin-top: 24px;" v-else>

                    <div class="fLabel">兑换商品</div>
                    <div> <el-input size="small" style="width: 442px;margin-left: 8px;" v-model="queryData.goodsName"
                            readonly placeholder="请选择" clearable></el-input></div>
                </div>
                <el-table style="margin-top: 24px;" :data="tableData" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品规格">
                        <template slot="header">
                            <div style="text-align:left">商品规格</div>
                        </template>
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <p>{{ scope.row.skuName }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="价格">
                        <template slot-scope="scope">
                            {{ scope.row.price }}
                        </template>
                    </el-table-column>
                    <el-table-column label="兑换所需积分">
                        <template slot="header">
                            <div style="text-align:left"><span style="color: red;">*</span>兑换所需积分</div>
                        </template>
                        <template slot-scope="scope">
                            <el-input size="small" v-model="scope.row.points" style="width: 100%;" />
                        </template>
                    </el-table-column>
                    <el-table-column label="兑换库存">
                        <template slot="header">
                            <div style="text-align:left"><span style="color: red;">*</span>兑换库存</div>
                        </template>
                        <template slot-scope="scope">
                            <el-input size="small" v-model="scope.row.stock" style="width: 100%;" />
                        </template>
                    </el-table-column>
                    <el-table-column label="虚拟兑换">
                        <template slot="header">
                            <div style="text-align:left">虚拟兑换</div>
                        </template>
                        <template slot-scope="scope">
                            <el-input size="small" v-model="scope.row.unrealSaleCount" style="width: 100%;" />
                        </template>
                    </el-table-column>
                    <el-table-column label="规格状态">
                        <template slot-scope="scope">
                            {{ scope.row.skuStatusLabel }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot="header">
                            <div style="text-align:center">是否兑换</div>
                        </template>
                        <template slot-scope="scope">
                            <!-- 已下架状态 不可用 -->
                            <el-switch v-model=scope.row.checkedL active-color="#2D46EE" inactive-color="#EBEEFA"
                                active-text="兑换" inactive-text="隐藏"
                                :disabled="scope.row.skuStatus === 0 && scope.row.checkedL === false">
                            </el-switch>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-button type="primary" @click="save()"
            style=" width: 184px;height: 40px;border-radius: 3px;font-size: 18px;background: #2D46EE;">保存</el-button>
        <el-dialog title="选择商品" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogGoods"
            width="60%">
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small" style="margin-top:20px">
                    <el-form-item>
                        <div style="display:flex">
                            <el-button :type="gType == '1' ? 'primary' : ''" size="small"
                                @click="selectG('1')">普通商品</el-button>
                            <el-button :type="gType == '2' ? 'primary' : ''" size="small"
                                @click="selectG('2')">礼包商品</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="" prop="tagName">
                        <el-input style="width: 232px" v-model="name" placeholder="请输入商品名称/商品编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData1('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData1('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="goodsList" v-if="gType == '1'" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品信息">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <img :src="scope.row.imageUrl" style="width: 72px; height: 56px; margin-right: 12px"
                                    alt="" />
                                <div style="
                                font-size: 14px;
                                min-height: 56px;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                              ">
                                    <p style="color: #333333">{{ scope.row.goodsName }}</p>
                                    <p style="color: #999999">
                                        商品编号：{{ scope.row.goodsNo }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型" width="200px">
                        <template slot-scope="scope">
                            普通商品
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot="header">
                            <div style="text-align:center">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <div style="text-align: center;margin-left:10px">
                                <div class="btn-y" v-if="scope.row.selected" @click="handleSelectGoods(scope)">已选取</div>
                                <div class="btn-s" v-else @click="handleSelectGoods(scope)">选取</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="gType == '1'" style="
                        display: flex;
                        justify-content: end;
                        align-items: center;
                        height: 42px;
                      ">
                    <el-pagination background @size-change="onGoodsSizeChange" @current-change="onGoodsCurrentChange"
                        :current-page="goodsPageNo" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum">
                    </el-pagination>

                </div>
                <el-table :data="goodsList1" v-if="gType == '2'" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品信息">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <img :src="scope.row.imageUrl" style="width: 72px; height: 56px; margin-right: 12px"
                                    alt="" />
                                <div style="
                                font-size: 14px;
                                min-height: 56px;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-between;
                              ">
                                    <p style="color: #333333">{{ scope.row.goodsName }}</p>
                                    <p style="color: #999999">
                                        商品编号：{{ scope.row.goodsNo }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型" width="200px">
                        <template slot-scope="scope">
                            礼包商品
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot="header">
                            <div style="text-align:center">操作</div>
                        </template>
                        <template slot-scope="scope">
                            <div style="text-align: center;margin-left:10px">
                                <div class="btn-y" v-if="scope.row.selected" @click="handleSelectGoods1(scope)">已选取
                                </div>
                                <div class="btn-s" v-else @click="handleSelectGoods1(scope)">选取</div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="gType == '2'" style="
                        display: flex;
                        justify-content: end;
                        align-items: center;
                        height: 42px;
                      ">
                    <el-pagination background @size-change="onGoodsSizeChange1" @current-change="onGoodsCurrentChange1"
                        :current-page="goodsPageNo1" :page-sizes="[5, 10, 20]" :page-size="goodsPageSize1"
                        layout="total, sizes, prev, pager, next, jumper" :total="goodsTotalNum1">
                    </el-pagination>
                </div>
            </div>
            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="dialogGoods = false">取消</div>
                <div class="info-s" @click="addShop">确定</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
export default {
    components: {
        breadcrumbTop,
    },
    data() {
        return {
            sGoods: [],
            title: '新增积分商品',
            dataList: {
                list: [
                    { title: '营销管理', path: '', type: '0' },
                    { title: '积分商城', path: '', type: '1' },
                    { title: '积分商品', path: '', type: '2' },
                ]
            },
            dialogGoods: false,
            name: '',
            goodsNo: '',
            gType: '1',
            goodsList: [],//商品数据
            goodsPageNo: 1,//商品表格页数
            goodsPageSize: 5,//商品表格每页显示条数
            goodsTotalNum: 0,//商品表格总条数
            goodsList1: [],//礼包商品数据
            goodsPageNo1: 1,//商品表格页数
            goodsPageSize1: 5,//商品表格每页显示条数
            goodsTotalNum1: 0,//商品表格总条数
            searchForm: {},
            seletedGoods: [],
            seletedGoods1: [],
            tableData: [

            ],
            goodsName: '',
            queryData: {
                type: 'add',
                goodsId: '',
                goodsType: '',
                id: '',
                goodsName: ''
            },

        }
    },
    mounted() {
        console.log(this.$route.query)
        this.queryData = this.$route.query
        if (this.queryData.type == 'add') {
            this.title = '新增积分商品'
        } else {
            this.title = '编辑积分商品'
            this.getDetail()
        }
    },
    methods: {
        save() {
            this.tableData.forEach(item => {
                if (item.checkedL == true) {
                    item.status = 1
                } else {
                    item.status = 0
                }
            })
            for (let item of this.tableData) {
                // 所需积分不能为空
                if (item.points === '' || item.points === null) {
                    return this.$message.error('兑换所需积分不能为空！');
                }
                // 库存不能为空
                if (item.stock === '' || item.stock === null) {
                    return this.$message.error('库存不能为空！');
                }
                // 虚拟兑换为空是改为0
                if (item.unrealSaleCount === '' || item.unrealSaleCount === null) {
                    item.unrealSaleCount = 0
                }
            }
            let goodsId = ''
            let goodsType = ''
            if (this.queryData.type == 'edit') {
                goodsId = this.queryData.goodsId
                goodsType = this.queryData.goodsType
            } else {
                goodsId = this.sGoods[0].id
                goodsType = this.sGoods[0].goodsType
            }
            let data = {
                goodsId: goodsId,
                goodsType: goodsType,
                id: this.queryData.id,
                skuList: this.tableData
            }
            this.axios.post('/point/goods/addOrEdit', data).then(res => {
                if (res.code === 0) {
                    this.$message.success('保存成功')
                    this.$router.go(-1)
                }
            })
        },
        getDetail() {
            let data = {
                checkedGoodsId: this.queryData.goodsId,
                checkedGoodsType: this.queryData.goodsType,
                pointGoodsId: this.queryData.id,
            }
            this.axios.post('/point/goods/getGoodsSkuList', data).then(res => {
                if (res.code === 0) {
                    res.data.forEach(item => {
                        if (item.status == 1) {
                            item.checkedL = true
                        } else {
                            item.checkedL = false
                        }

                    })
                    this.tableData = res.data
                } else {
                    console.log('goodsPageList - 失败', type)
                }
            })
        },
        addShop() {
            this.dialogGoods = false
            this.sGoods = []
            if (this.gType == 1) {
                this.sGoods = this.seletedGoods
            } else {
                this.sGoods = this.seletedGoods1
            }
            let data = {
                checkedGoodsId: this.sGoods[0].id,
                checkedGoodsType: this.sGoods[0].goodsType,
                pointGoodsId: this.queryData.id,
            }
            this.axios.post('/point/goods/getGoodsSkuList', data).then(res => {
                if (res.code === 0) {
                    res.data.forEach(item => {
                        if (item.status == 1) {
                            item.checkedL = true
                        } else {
                            item.checkedL = false
                        }

                    })
                    this.tableData = res.data
                    this.goodsName = this.sGoods[0].goodsName
                } else {
                    console.log('goodsPageList - 失败', type)
                }
            })
        },
        fetchData1(type) {
            if (type == 'reset') {
                this.name = ''
                this.goodsNo = ''
            }
            this.goodsPageNo = 1
            this.goodsPageNo1 = 1
            this.getGoodsList()
        },
        selectGoods() {
            console.log(444)
            this.dialogGoods = true
            this.getGoodsList()
        },
        onGoodsSizeChange(e) {
            this.goodsPageSize = e;
            this.getGoodsList()
        },
        onGoodsCurrentChange(e) {
            this.goodsPageNo = e;
            this.getGoodsList()
        },
        onGoodsSizeChange1(e) {
            this.goodsPageSize1 = e;
            this.getGoodsList()
        },
        onGoodsCurrentChange1(e) {
            this.goodsPageNo1 = e;
            this.getGoodsList()
        },
        //选择商品
        handleSelectGoods(scope) {
            this.seletedGoods = []
            if (!scope.row.selected) {
                for (let i = 0; i < this.goodsList.length; i++) {
                    if (i == scope.$index) {
                        this.goodsList[scope.$index].selected = !this.goodsList[scope.$index].selected
                    } else {
                        this.goodsList[i].selected = false;
                    }
                }
                this.seletedGoods.push(scope.row)
            } else {
                this.goodsList[scope.$index].selected = false;
                this.goodsL = []
            }
            console.log(this.seletedGoods)

            this.$forceUpdate()
        },
        selectG(val) {
            this.gType = val
            this.goodsPageNo = 1
            this.getGoodsList()//获取商品数据
        },
        //选择商品
        handleSelectGoods1(scope) {
            this.seletedGoods1 = []
            if (!scope.row.selected) {
                for (let i = 0; i < this.goodsList1.length; i++) {
                    if (i == scope.$index) {
                        this.goodsList1[scope.$index].selected = !this.goodsList1[scope.$index].selected
                    } else {
                        this.goodsList1[i].selected = false;
                    }
                }
                this.seletedGoods1.push(scope.row)
            } else {
                this.goodsList1[scope.$index].selected = false;
                this.goodsL = []
            }
            console.log(this.seletedGoods1)
            this.$forceUpdate()
        },
        //获取商品数据
        getGoodsList() {
            if (this.gType == 1) {
                let data = {
                    pageNo: this.goodsPageNo,
                    pageSize: this.goodsPageSize,
                    name: this.name,
                    goodsType: 1
                }
                this.axios.post('/point/goods/getGoodsPage', data).then(res => {
                    if (res.code === 0) {
                        res.data.list.forEach(item => {
                            item.selected = false
                        })
                        this.goodsList = res.data.list;
                        this.seletedGoods.forEach(item => {
                            this.goodsList.forEach(el => {
                                if (item.id == el.id) {
                                    el.selected = true;
                                }
                            })
                        })
                        this.goodsTotalNum = res.data.totalNum
                    } else {
                        console.log('goodsPageList - 失败', type)
                    }
                })
            } else {
                let data = {
                    pageNo: this.goodsPageNo1,
                    pageSize: this.goodsPageSize1,
                    name: this.name,
                    goodsType: 2
                    // activateId: this.$route.query.id
                }
                this.axios.post('/point/goods/getGoodsPage', data).then(res => {
                    if (res.code === 0) {
                        res.data.list.forEach(item => {
                            item.selected = false
                        })
                        this.goodsList1 = res.data.list;
                        this.seletedGoods1.forEach(item => {
                            this.goodsList1.forEach(el => {
                                if (item.id == el.id) {
                                    el.selected = true;
                                }
                            })
                        })
                        this.goodsTotalNum1 = res.data.totalNum
                    } else {
                        console.log('goodsPageList - 失败', type)
                    }
                })
            }

        },
    }
}
</script>
<style scoped>
::v-deep .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
    z-index: 1;
    right: 20px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
    z-index: 1;
    left: 20px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
    display: block;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
    width: 60px !important;
}

.info1 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #303033;
    line-height: 30px;
}

.content-content {
    min-height: 500px;
}

.fLabel {
    /* width: 67px; */
    height: 19px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #303033;
    line-height: 30px;
}

.btn-y {
    width: 64px;
    height: 32px;
    background: #2D46EE;
    opacity: 1;
    border-radius: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
}

.btn-s {
    width: 64px;
    height: 32px;
    background: #E9ECFE;
    opacity: 1;
    border-radius: 16px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 32px;
    color: #2D46EE;
    text-align: center;
    cursor: pointer;
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}
</style>